module.exports = __webpack_public_path__ + "img/welfare-ico-2.43549756.png";